import React from "react"
import Slider from "react-slick"


const Step = ({step}) => {

    const settings1 = {
        infinite:!0,
        dots:!0,
        vertical:!1,
        verticalSwiping:!1,
        slidesToShow:1,
        slidesToScroll:1,
        arrows:!0,
        className: "caroussel-etape",
        dots: true,
        autoplay: true,
        autoplaySpeed: 3000,
      }

    const steps = step && [...step];

    return (
        <Slider {...settings1}>
            {
                steps && steps.map((res,index) => {
                    return (
                        <div key={index} className="list">
                            <div className="content">
                                <div className="num">{index+1} 
                                </div>
                                <div className="text">
                                    <p>{res.description}</p>
                                </div>
                            </div>
                        </div>
                    )
                })
            }
           
        </Slider>

    )
}

export default Step